import React from 'react';
import { Button, IconButton, Modal } from '@material-ui/core';
import { X, AlertTriangle } from 'tabler-icons-react';
import '../styles/llamadas.css';

export default function ConfirmModal({ open, onClose, onConfirm, title, children, confirmText = 'Eliminar', confirmColor = '#e53935' }) {
    return (
        <Modal open={open} onClose={onClose}>
            <div className="llamada-modal llamada-modal--confirm">
                <div className="llamada-modal-header">
                    <h2 className="popuptitle">{title}</h2>
                    <IconButton size="small" onClick={onClose}><X size={20} /></IconButton>
                </div>

                <div className="llamada-modal-body confirm-modal-body">
                    <div className="confirm-modal-icon">
                        <AlertTriangle size={32} color={confirmColor} />
                    </div>
                    <div className="confirm-modal-text">{children}</div>
                </div>

                <div className="llamada-modal-footer">
                    <Button variant="outlined" color="primary" onClick={onClose}>Cancelar</Button>
                    <Button
                        variant="contained"
                        className="confirm-modal-btn-delete"
                        onClick={onConfirm}
                    >
                        {confirmText}
                    </Button>
                </div>
            </div>
        </Modal>
    );
}
